<template>
    <div class="warmSet">
        <el-form ref="form" :model="form" label-width="90px" class="demo-item" label-position="left" size="mini">
            <el-form-item label="暖场效果">
                <el-switch v-model="form.isopenpreview" :active-value=1 :inactive-value=0 :disabled="isEnd"></el-switch>
                <span class="tips magin20">开启后可以在直播开始前展示暖场图或者播放视频</span>
            </el-form-item>
            <el-form-item label="暖场效果" v-show="form.isopenpreview">
                <el-radio-group v-model="form.previewtype" :disabled="isEnd">
                    <el-radio :label="1">暖场图</el-radio>
                    <el-radio :label="2">暖场视频</el-radio>
                </el-radio-group>
                <div class="warm_box" v-show="form.previewtype==1">
                    <!--<upload class="headImage" :imgRule="imgRule" ref="logofile" @setImage="setLogourl" :uploadType="uploadType" v-if="!isDisabled"></upload>-->
                    <div class="upload headImage" @click="openLocalGallery">
                        <div class="avatar-uploader">
                            <div tabindex="0" class="el-upload el-upload--text">
                                <i class="el-icon-plus avatar-uploader-icon icon_upload" v-if="!form.coverurl"></i>
                                <img :src="form.coverurl" class="avatar" v-else>
                            </div>
                        </div>
                    </div>
                    <div class="el-upload__tip">
                        <el-button type="primary" @click="openSystemGallery" :disabled="isEnd">素材库</el-button>
                        <div>建议像素：750x422px或16:9，JPG、PNG格式，大小不超过5M。 </div>
                    </div>
                </div>
                <div class="warm_box" v-show="form.previewtype==2">
                    <div class="upload headImage">
                        <div class="avatar-uploader">
                            <div tabindex="0" class="el-upload el-upload--text">
                                <img :src="videoBg" alt="" v-show="!form.previewurl">
                                <video :src="form.previewurl" controls preload v-show="form.previewurl"></video>
                            </div>
                        </div>
                    </div>
                    <div class="el-upload__tip">
                        <uploadFile :uploadType="uploadVideoType" @setFile="setFile" :fileRule="fileRule" class="videoBtn" :disabled="isEnd"></uploadFile>
                        <el-button type="warning" class="btn" @click="openVideoScrollBox" :disabled="isEnd">素材库</el-button>
                        <div>建议大小：1280x720，MP4格式，大小不超过1G。 </div>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary" class="saveBtn" @click="saveEvent" v-if="!isEnd">保存</el-button>
            </el-form-item>
        </el-form>
        <localCropper :cropperOption="cropperOption" ref="localCropper" @setImage="editImage" :uploadType="uploadType"></localCropper>
        <systemCropper :cropperOption="cropperOption" ref="systemCropper" @setImage="editImage"  :uploadType="uploadType"></systemCropper>
        <!--视频-->
        <scrollBox ref="videoScrollBox" :uploadType="uploadVideoType" @saveMaterialFile="setMaterialVideofile"></scrollBox>
    </div>
</template>

<script>
    import {uploadLivePreviewSetting} from 'api/vliveV2Api'
    import LocalCropper from 'base/cropper/localCropper'
    import SystemCropper from 'base/cropper/systemCropper'
    import UploadFile from 'base/upload/uploadFile'
    import ScrollBox from 'base/scrollBox/scrollBox'
    import {mapGetters, mapActions} from 'vuex'
    import {formatFileInfo} from 'common/js/tools'
    export default {
        name: "warmSet",
        data(){
            return{
                videoBg:require('@/common/images/vliveV2/videoBg.png'),
                isDisabled:false,
                form:{
                    liveid:'', //直播id
                    isopenpreview:false, //是否开启暖场设置
                    previewtype:1, //暖场类型 1图片 2类型
                    previewid:'', //暖场视频id
                    previewurl:'', //暖场视频url
                    coverattid:'', //暖场图视频id
                    coverurl:'', //暖场图视频url
                    // logourl:'', //暖场图url
                    // videourl:'', //暖场视频url
                },
                logoPic: { //暖场图
                    bucket: '',
                    fname: '',
                    fsize: '',
                    width: '',
                    height: '',
                    key: '',
                    mimeType: '',
                    objecttype: '',
                    furl: ''
                },
                videoInfo: { //暖场视频
                    duration: '',
                    bucket: '',
                    fname: '',
                    fsize: '',
                    width: '',
                    height: '',
                    key: '',
                    mimeType: '',
                    objecttype: '',
                    furl: ''
                },
                timestamp: new Date().getTime(), // 时间戳
                cropperOption: {
                    fixedNumber: [1280, 720], // 截图框的宽高比例
                    enlarge: 4, // 图片根据截图框输出比例倍数
                    autoCropWidth: 320, // 默认生成截图框宽度
                    autoCropHeight: 180 // 默认生成截图框高度
                },
                //图片
                uploadType: {
                    catecode: '95',
                    datatype: 'IMAGE'
                },
                imgRule: {
                    cls: 'icon_upload',
                    accept: 'image/png,image/jpeg',
                    size: 5,
                    width: '',
                    height: ''
                },
                //视频
                uploadVideoType: {
                    catecode: '95',
                    datatype: 'VIDEO'
                },
                fileRule: {
                    btnName: '本地上传',
                    cls: '',
                    accept: 'video/mp4',
                    size: 5 * 1024,
                    width: '',
                    height: ''
                },
                isEnd:false
            }
        },
        mounted() {
            //暖场图
            this.form=JSON.parse(JSON.stringify(this.playInfo.warmfieldinfo));
            this.isEnd=[10,100].indexOf(this.liveInfo.status)>=0
            // this.form.liveid=this.liveInfo.liveid
            // this.$refs.logofile.setImage(this.form.logoPic.furl)
        },
        methods:{
            //保存
            saveEvent(){
                if(this.form.previewtype==1&&this.form.coverurl==''){
                    this.$message({
                        message: '请选择暖场图',
                        type: 'warning'
                    });
                    return
                }
                if(this.form.previewtype==2&&this.form.previewurl==''){
                    this.$message({
                        message: '请选择暖场视频',
                        type: 'warning'
                    });
                    return
                }else{
                    this.setLoading(true);
                    uploadLivePreviewSetting({
                        data: Object.assign({}, this.form),
                        success: data => {
                            this.setLoading(false);
                            this.$message({
                                type: 'success',
                                message: '保存成功'
                            })
                        },
                        error: data => {
                            this.setLoading(false);
                            this.$message.error(data.msg)
                        }
                    })
                }
            },
            //打开本地图片（暖场图）
            openLocalGallery() {
                if(!this.isEnd){
                    this.$refs.localCropper.openDialog()
                }
            },
            //打开素材库（暖场图）
            openSystemGallery() {
                this.$refs.systemCropper.openDialog()
            },
            //上传图片后展示
            editImage (file) {
                this.timestamp = new Date().getTime()
                this.logoPic = file;
                this.form.coverurl=file.furl
                this.form.coverattid=file.key
            },
            // 打开视频素材库选择框
            openVideoScrollBox() {
                this.$refs.videoScrollBox.openDialog()
            },
            // 设置素材库选择的视频信息
            setMaterialVideofile(file) {
                this.setFile(file)
            },
            //上传后展示视频
            setFile(file) {
                this.timestamp = new Date().getTime();
                this.videoInfo = file;
                this.form.previewurl=file.furl
                this.form.previewid=file.key
            },
            ...mapActions([
                'setLoading','setLiveInfo','setPlayInfo'
            ])
        },
        computed: {
            ...mapGetters([
                'liveInfo','playInfo'
            ])
        },
        components: {
            UploadFile,ScrollBox,LocalCropper,SystemCropper
        },
    }
</script>

<style lang="scss">
    .warmSet{
        .tips{
            color: #999;
            font-size: 13px;
        }
        .magin20{
            padding-left: 20px;
        }
        .warm_box{
            display: flex;
            align-items: flex-end;
            margin-top: 20px;
            .headImage .avatar-uploader{
                box-sizing: border-box;
                width: 320px;
                height: 180px;
                margin-right: 20px;
            }
            .el-upload__tip{
                .videoBtn{
                    margin-bottom: 10px;
                }
                div{
                    margin-top: 10px;
                    color: #999;
                }
            }
            video{
                width: 100%;
                height: 100%;
            }
        }
        .saveBtn{
            margin-top: 20px;
        }
    }
</style>
